export const stateOption = [
  { label: "Solicitud", value: "SUBMISSION" },
  { label: "Proyecto", value: "PROJECT" }
]
